import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    channel: { type: String, default: "email" },
    mode: { type: String, default: "edit" },
  };

  connect() {
    this.update();
  }

  switchChannel(event) {
    this.channelValue = event.currentTarget.dataset.channel;
    this.update();
  }

  switchMode(event) {
    this.modeValue = event.currentTarget.dataset.mode;

    // If switching to preview, save draft then reload the preview frame
    if (this.modeValue === "preview") {
      const frameId = `composer-preview-${this.channelValue}`;
      const frame = document.getElementById(frameId);
      if (frame) {
        // Dispatch event so draft controller saves first
        const saveEvent = new CustomEvent("composer-tabs:preview", {
          detail: { frameId, channel: this.channelValue },
          bubbles: true,
        });
        this.element.dispatchEvent(saveEvent);
      }
    }

    this.update();
  }

  update() {
    // Update channel buttons
    this.element.querySelectorAll("[data-channel]").forEach((btn) => {
      btn.classList.toggle("active", btn.dataset.channel === this.channelValue);
    });

    // Update mode buttons
    this.element.querySelectorAll("[data-mode]").forEach((btn) => {
      btn.classList.toggle("active", btn.dataset.mode === this.modeValue);
    });

    // Show/hide panels
    this.element.querySelectorAll("[data-panel]").forEach((panel) => {
      const [channel, mode] = panel.dataset.panel.split("-");
      panel.classList.toggle(
        "hidden",
        channel !== this.channelValue || mode !== this.modeValue,
      );
    });

    // Show/hide toolbar (only for email edit)
    const toolbar = this.element.querySelector("[data-composer-toolbar]");
    if (toolbar) {
      toolbar.classList.toggle(
        "hidden",
        this.channelValue !== "email" || this.modeValue !== "edit",
      );
    }

    // Show/hide channel-specific headers
    this.element
      .querySelectorAll("[data-composer-channel-header]")
      .forEach((header) => {
        header.classList.toggle(
          "hidden",
          header.dataset.composerChannelHeader !== this.channelValue,
        );
      });
  }
}
